export const getSectionCardStyle = ({ theme }) => ({
  backgroundColor: theme.palette.common.white,
  padding: theme.spacing(3),
  borderRadius: theme.radius.md,
  boxShadow: '0px 3px 10px 0px rgba(0, 0, 0, 0.08)',
});

export const getMaxWidthContainerParent = () => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  width: 'auto',
});
